module.exports = __webpack_public_path__ + "static/MammothMoving-585d949517d10735844a94360ebd612c.gif";